const _temp0 = require("../globals/components/base/Autocomplete.vue");
const _temp1 = require("../globals/components/base/Avatar.vue");
const _temp2 = require("../globals/components/base/BaseIcon.vue");
const _temp3 = require("../globals/components/base/CodeInput.vue");
const _temp4 = require("../globals/components/base/DatePicker.vue");
const _temp5 = require("../globals/components/base/DropdownSelect.vue");
const _temp6 = require("../globals/components/base/ExpansionPanel.vue");
const _temp7 = require("../globals/components/base/FormGroup.vue");
const _temp8 = require("../globals/components/base/FormInput.vue");
const _temp9 = require("../globals/components/base/Loader.vue");
const _temp10 = require("../globals/components/base/MessageBar.vue");
const _temp11 = require("../globals/components/base/ModalDialog.vue");
const _temp12 = require("../globals/components/base/OferteoLogo.vue");
const _temp13 = require("../globals/components/base/PageHeader.vue");
const _temp14 = require("../globals/components/base/ProgressBar.vue");
const _temp15 = require("../globals/components/base/Rating.vue");
const _temp16 = require("../globals/components/base/StarRating.vue");
const _temp17 = require("../globals/components/base/TimePicker.vue");
module.exports = {
  "Autocomplete": _temp0,
  "Avatar": _temp1,
  "BaseIcon": _temp2,
  "CodeInput": _temp3,
  "DatePicker": _temp4,
  "DropdownSelect": _temp5,
  "ExpansionPanel": _temp6,
  "FormGroup": _temp7,
  "FormInput": _temp8,
  "Loader": _temp9,
  "MessageBar": _temp10,
  "ModalDialog": _temp11,
  "OferteoLogo": _temp12,
  "PageHeader": _temp13,
  "ProgressBar": _temp14,
  "Rating": _temp15,
  "StarRating": _temp16,
  "TimePicker": _temp17
}